import { render, staticRenderFns } from "./accordion-inbox.vue?vue&type=template&id=86a85df2&"
import script from "./accordion-inbox.vue?vue&type=script&lang=js&"
export * from "./accordion-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports